import { Component } from '@angular/core';
import { DictionaryDropdownInput } from 'src/app/shared/dictionary-dropdown/dropdown-input';

@Component({
  templateUrl: './dictionary.component.html',
  styleUrls: ['./dictionary.component.scss'],
  standalone: false
})
export class DictionaryComponent {
  public dictionary: DictionaryDropdownInput[] = [
    {
      translateKey: 'rebalancing',
    },
    {
      translateKey: 'riskProfile',
    },
  ];
}
